// @flow

import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";
import * as styles from "./styles";
import * as colors from "src/styles/constants/colors";

type Props = {
  message: string,
  isShown: boolean,
  onClick: Function,
  children: any,
  position?: "bottom" | "top",
  color?: string,
  textColor?: string,
};

const InteractiveToolTip = ({
  message,
  isShown,
  children,
  onClick,
  position = "bottom",
  color = colors.red500,
  textColor = "white",
}: Props) => {
  return (
    <Popover trigger={isShown ? "hover" : null} placement={position}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent color={textColor} background={color} sx={styles.tooltip}>
        <PopoverBody onClick={onClick} textDecoration="underline">
          {message}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default InteractiveToolTip;
